import { PortalModule } from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IconModule } from '../icon/icon.module';
import { LinkModule } from '../link/link.module';
import { CalloutContentComponent } from './callout-content.component';
import { CalloutTriggerComponent } from './callout-trigger.component';
import { CalloutComponent } from './callout.component';

@NgModule({
  imports: [CommonModule, IconModule, LinkModule, PortalModule],
  declarations: [
    CalloutComponent,
    CalloutTriggerComponent,
    CalloutContentComponent,
  ],
  exports: [CalloutComponent, CalloutTriggerComponent, CalloutContentComponent],
})
export class CalloutModule {}



// WEBPACK FOOTER //
// ./src/app/@shared/ui/callout/callout.module.ts